import { render, staticRenderFns } from "./AccessoriesOrdering.vue?vue&type=template&id=c0eb704a&scoped=true&"
import script from "./AccessoriesOrdering.vue?vue&type=script&lang=js&"
export * from "./AccessoriesOrdering.vue?vue&type=script&lang=js&"
import style0 from "./AccessoriesOrdering.vue?vue&type=style&index=0&id=c0eb704a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0eb704a",
  null
  
)

export default component.exports